'use es6';

import events from 'pricing-pages-unified-ui/events.yaml';
import { APP } from 'pricing-pages-unified-ui/constants/Tracking';
import Raven from 'Raven';
export default {
  events,
  properties: {
    namespace: APP
  },
  lastKnownEventProperties: ['screen', 'subscreen'],
  onError: err => {
    Raven.captureMessage('usage-tracker-js event error', {
      extra: {
        message: err.message
      }
    });
  }
};